import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import { PERMISSIONS_KEY, ROUTES } from '../../common/constants';
import Error404 from '../../Error404';
import Roadmaps from './modules/roadmaps/pages/Roadmaps';
import './ultraPlan.less';
import {
  ULTRA_PLAN_ALLOWED_ROLES,
  ULTRA_PLAN_ROUTES,
} from './ultraPlanConstants';

const UltraPlanWrapper = () => (
  <Switch>
    <Route
      exact
      path={ROUTES?.ULTRA_PLAN}
      render={() => (
        <Redirect to={`${ROUTES?.ULTRA_PLAN}${ROUTES?.ROADMAPS}`} />
      )}
    />
    <Route
      exact
      path={[
        ULTRA_PLAN_ROUTES?.LIST,
        ULTRA_PLAN_ROUTES?.ROADMAP,
        ULTRA_PLAN_ROUTES?.SUBSCRIBER,
      ]}
      render={(props) => (
        <AccessControl
          permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS}
          allowedRoles={ULTRA_PLAN_ALLOWED_ROLES}
        >
          <Roadmaps {...props} />
        </AccessControl>
      )}
    />
    <Route path="*" exact component={Error404} />
  </Switch>
);

export default UltraPlanWrapper;
